import React, { useState } from 'react';

const API_URL = 'https://dear-bea-website.onrender.com';


const ReviewForm = ({ onClose, onSubmit }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    rating: 5,
    review: '',
  });
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);


  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);

    try {
      const response = await fetch(`${API_URL}/api/reviews`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(formData),
      });

      const data = await response.json();

      if (data.success) {
        setSuccess(true);
  onSubmit?.();

  // auto-close after a short delay
  setTimeout(() => {
    onClose();
  }, 3000);
      }
    } catch (error) {
      console.error('Error submitting review:', error);
      alert('There was an error submitting your review. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 backdrop-blur-sm flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-3xl max-w-2xl w-full shadow-romantic">
        {/* Header */}
        <div className="bg-gradient-romantic rounded-t-3xl p-8 text-center relative">
          <button
            onClick={onClose}
            className="absolute top-6 right-6 text-white hover:text-gray-200 text-3xl font-light"
          >
            ×
          </button>
          <h2 className="text-4xl font-display font-bold text-white mb-2">
            Leave a Review
          </h2>
          <p className="text-white text-lg font-serif">Share your experience with Dear Bea</p>
        </div>

        {/* Form */}
        <div className="p-8">

  {/* ✅ SUCCESS MESSAGE GOES HERE */}
  {success && (
    <div className="mb-6 p-4 bg-green-100 border border-green-400 text-green-700 rounded-xl text-sm md:text-base text-center font-semibold">
      💕 Thank you for your review!  
      <br />
      It will be published after approval.
    </div>
  )}
          <form onSubmit={handleSubmit} className="space-y-6">
            {/* Rating */}
            <div>
              <label className="block text-gray-700 font-semibold mb-3 font-sans">
                Your Rating 
              </label>
              <div className="flex gap-2">
                {[1, 2, 3, 4, 5].map((star) => (
                  <button
                    key={star}
                    type="button"
                    onClick={() => setFormData({ ...formData, rating: star })}
                    className="focus:outline-none transition-transform hover:scale-110"
                  >
                    <svg
                      className={`w-12 h-12 ${
                        star <= formData.rating
                          ? 'text-yellow-400 fill-current'
                          : 'text-gray-300'
                      }`}
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                      strokeWidth="1"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        d="M11.049 2.927c.3-.921 1.603-.921 1.902 0l1.519 4.674a1 1 0 00.95.69h4.915c.969 0 1.371 1.24.588 1.81l-3.976 2.888a1 1 0 00-.363 1.118l1.518 4.674c.3.922-.755 1.688-1.538 1.118l-3.976-2.888a1 1 0 00-1.176 0l-3.976 2.888c-.783.57-1.838-.197-1.538-1.118l1.518-4.674a1 1 0 00-.363-1.118l-3.976-2.888c-.784-.57-.38-1.81.588-1.81h4.914a1 1 0 00.951-.69l1.519-4.674z"
                      />
                    </svg>
                  </button>
                ))}
              </div>
              <p className="text-sm text-gray-500 mt-2 font-sans">
                {formData.rating === 5
                  ? 'Excellent!'
                  : formData.rating === 4
                  ? 'Great!'
                  : formData.rating === 3
                  ? 'Good'
                  : formData.rating === 2
                  ? 'Fair'
                  : 'Poor'}
              </p>
            </div>

            {/* Name */}
            <div>
              <label className="block text-gray-700 font-semibold mb-2 font-sans">
                Your Name 
              </label>
              <input
                type="text"
                name="name"
                value={formData.name}
                onChange={handleChange}
                required
                className="input-romantic"
                placeholder="John Smith"
              />
            </div>

            {/* Email */}
            <div>
              <label className="block text-gray-700 font-semibold mb-2 font-sans">
                Email 
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                required
                className="input-romantic"
                placeholder="your.email@example.com"
              />
              <p className="text-xs text-gray-500 mt-1 font-sans">
                Your email will not be published
              </p>
            </div>

            {/* Review */}
            <div>
              <label className="block text-gray-700 font-semibold mb-2 font-sans">
                Your Review 
              </label>
              <textarea
                name="review"
                value={formData.review}
                onChange={handleChange}
                required
                rows="5"
                className="input-romantic resize-none"
                placeholder="Tell us about your experience with Dear Bea..."
              />
            </div>

            {/* Submit Button */}
            <button
              type="submit"
              disabled={submitting}
              className={`btn-primary w-full ${
                submitting ? 'opacity-50 cursor-not-allowed' : ''
              }`}
            >
              {submitting ? (
                <span className="flex items-center justify-center gap-3">
                  <svg className="animate-spin h-5 w-5" viewBox="0 0 24 24">
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                      fill="none"
                    />
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                    />
                  </svg>
                  Submitting...
                </span>
              ) : (
                'Submit Review'
              )}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ReviewForm;